'use client';

export { default } from './Hidden';